/**
 * 区分 customerType（customers.customer_type）
 * 出典：要件書 5.2
 */
export const CUSTOMER_TYPE_VALUES = ['company', 'soleProprietor'] as const;

export type CustomerType = (typeof CUSTOMER_TYPE_VALUES)[number];

export const CUSTOMER_TYPE_LABELS: Readonly<Record<CustomerType, string>> = {
  company: '企業',
  soleProprietor: '個人事業主',
};
